var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandMoneyCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.25C17.239 11.25 18.75 9.73896 18.75 7.875C18.75 6.01104 17.239 4.5 15.375 4.5C13.511 4.5 12 6.01104 12 7.875C12 9.73896 13.511 11.25 15.375 11.25Z",
    fill: "#8494AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4234 12.375C22.2734 12.15 22.0484 12 21.7484 12C20.0984 12 18.5234 12.75 17.5484 14.1L16.8734 15C16.0484 15.975 14.7734 16.5 13.4984 16.5H11.2484C10.7984 16.5 10.4984 16.2 10.4984 15.75C10.4984 15.3 10.7984 15 11.2484 15H12.6734C13.8734 15 14.9984 14.025 14.9984 12.825V12.75C14.9984 12.375 14.6234 12 14.2484 12H9.67344C6.97344 12 4.79844 13.2 3.59844 15.15L1.57344 18.3C1.42344 18.525 1.42344 18.825 1.57344 19.05L3.82344 22.8C3.89844 22.95 4.12344 23.1 4.27344 23.175C4.34844 23.175 4.34844 23.175 4.42344 23.175C4.57344 23.175 4.72344 23.1 4.87344 23.025C7.72344 21.15 11.0234 20.175 14.3984 20.175C16.8734 20.175 19.1234 18.825 20.3234 16.65L22.3484 13.05C22.4984 12.9 22.4984 12.6 22.4234 12.375Z",
    fill: "#8494AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.875C10.5 6 11.625 4.35 13.2 3.525C12.675 2.325 11.475 1.5 10.125 1.5C8.25 1.5 6.75 3 6.75 4.875C6.75 6.75 8.25 8.25 10.125 8.25C10.275 8.25 10.35 8.25 10.5 8.175C10.5 8.1 10.5 8.025 10.5 7.875Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandMoneyCash);
export default __webpack_public_path__ + "static/media/hand-money-cash.2d9a638f0fd8235fa2ae53d485572a5d.svg";
export { ForwardRef as ReactComponent };